// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const SubscriptTag: MarkdocTagRegistration = {
  tag: 'sub',
  component: 'Subscript',
};
